import React from "react"

import { Color } from "../../../constants/V2/color"
import Typography from "../../elements/V2/Typography"
import LayoutItem from "../Layouts/LayoutItem"

import QuotationMarkIcon from "@components/elements/V2/Icons/QuotationMarkIcon"

type QuestionAnswerProps = {
  question: string
  iconColor?: Color
  answers: { value: string }[]
  mobileGridOrder?: number
}

const QuestionAnswer = ({
  answers,
  question,
  iconColor,
  mobileGridOrder,
  ...props
}: QuestionAnswerProps) => {
  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      className="col-span-full flex flex-col gap-8 overflow-hidden sm:gap-16"
      {...props}
    >
      <div data-aos-offset="150" className="col-span-2" data-aos="fade-right">
        <Typography
          size="body-lg"
          weight="medium"
          text={question}
          font="grotesk"
          color={Color.Black}
        />
      </div>

      <div className="flex gap-8">
        <div
          data-aos="fade"
          data-aos-duration="300"
          data-aos-offset="200"
          className="flex-shrink"
        >
          <div className="flex h-24 w-24 justify-center pt-4 md:pt-[6px]">
            <QuotationMarkIcon fill={iconColor} width={14.73} height={11.03} />
          </div>
        </div>

        {answers && answers.length > 0 ? (
          <div
            className="flex flex-1 flex-col gap-y-20"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            {answers.map(({ value }, index) => (
              <Typography
                key={index}
                weight="book"
                text={value}
                font="grotesk"
                color={Color.Black}
                size="body-md"
              />
            ))}
          </div>
        ) : null}
      </div>
    </LayoutItem>
  )
}

export default QuestionAnswer
